module.exports = __webpack_public_path__ + "img/button.ed18345.svg";